module.exports = __webpack_public_path__ + "static/media/Ann2.9d172792.jpg";